import { GradientType } from '@ui/types'
import { colors } from '@ui/colors'
import { TextPaperStatus } from './types'

export const borderRadius = 24

export const colorText: Record<TextPaperStatus, string> = {
  default: colors.text,
  empty: colors.black25,
  success: colors.green[600],
  danger: colors.red[600],
}

export const colorLines: Record<TextPaperStatus, string> = {
  default: colors.black50,
  empty: colors.black25,
  success: colors.black,
  danger: colors.red50,
}

export const colorBorder: Record<TextPaperStatus, string> = {
  default: colors.black10,
  empty: colors.black10,
  success: colors.green50,
  danger: colors.red50,
}

export const borderWidth: Record<TextPaperStatus, number> = {
  default: 1,
  empty: 1,
  success: 2,
  danger: 2,
}

export const colorBackground: Record<TextPaperStatus, GradientType> = {
  default: [colors.gray[50], colors.white],
  empty: [colors.white, colors.white],
  success: [colors.green5, colors.white0],
  danger: [colors.red5, colors.white0],
}

export const colorPressed: Record<TextPaperStatus, string> = {
  default: colors.gray[100],
  empty: colors.black10,
  success: colors.green10,
  danger: colors.red10,
}
